export default __webpack_public_path__ + "static/media/bar-roles.b48bb9dd.svg";